import React from "react";
import { BsArrowRight } from "react-icons/bs";
import lookbookImage1 from "../../images/lookbook1.jpg";
import lookbookImage2 from "../../images/lookbook2.jpg";
import lookbookImage3 from "../../images/lookbook3.jpg";
import { Link } from "react-router-dom";

const Section8 = () => {
  return (
    <div>
      <section className="lookbook bg-light">
        <div className="container flow-content split">
          <div className="lookbook__text">
            <h2 className="section-heading">Lookbook</h2>
            <p>
              We design experiences. Here’s a peek at some of the celebrations
              we’ve brought to life.
            </p>
            <div>
              
              <Link to="/gallery" className="primary-btn">
                <span className="arrow__icon">
                  <BsArrowRight />
                </span>
                <span>View More</span>
              </Link>
            </div>
          </div>
          <div className="lookbook__images split">
            <div>
              <img src={lookbookImage1} alt="" />
            </div>
            <div>
              <img src={lookbookImage2} alt="" />
            </div>
            <div>
              <img src={lookbookImage3} alt="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Section8;
